export default __webpack_public_path__ + "static/media/img_11.ff712590.JPG";